// @flow
import BaseComponent from '../base_component/base_component'

export default class Navbar extends BaseComponent {
    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
        //this.addAndRemoveBackground();
    }

    // scrollTo(target: string) {
    //     $('html, body').animate({
    //         scrollTop: $(`#${target}`).offset().top
    //     }, 'slow');
    //     return false;
    // }

    // addAndRemoveBackground() {
    //     $(window).scroll( function (event) {
    //         $('.logo-image').addClass('logo-shrink');
    //         $('.hero-login-mobile').addClass('logo-shrink');
    //         $('.header-fixed').css({'position': 'fixed', 'background':'#003366', 'transition': '0.5s'});
    //     });
    // }

    // showLogin() {
    //     $(this.component).find('.hero-login').attr('style', '');
    //     this.scrollTo('home');
    // }
}
